<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="会计年度">
              <a-input placeholder="请输入年度" v-model="queryParam.fyear" max="4"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="期间">
              <a-input placeholder="请输入期间" v-model="queryParam.fperiod" max="2"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="凭证日期">
              <a-date-picker placeholder="请输入日期" v-model="queryParam.fdate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="凭证号">
              <a-input placeholder="请输入凭证号" v-model="queryParam.fvoucherId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="height:40px; margin-bottom: 16px;">
        <span style="float:right; ">金额单位：元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

      </a-table>
    </div>
    <!-- table区域-end -->

  </a-card>
</template>

<script>
  import moment from 'moment'
  import '@/assets/less/TableExpand.less'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "BizFinancialVoucherList",
    mixins:[JeecgListMixin],
    components: {
      // BizFinancialVoucherModal
    },
    data () {
      return {
        disableMixinCreated: true, //禁止mixin初始加载
        description: '财务凭证表管理页面',
        queryParam:{
          fyear:'',
          fperiod:'',
          fdate:'',
          fvoucherId:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
          {
            title: '账簿编号',
            align:"center",
            dataIndex: 'faccountbookid'
          },
		      {
            title: '凭证日期',
            align:"center",
            dataIndex: 'fdate'
           },
		      {
            title: '会计年度',
            align:"center",
            dataIndex: 'fyear'
           },
		      {
            title: '期间',
            align:"center",
            dataIndex: 'fperiod'
           },
		      {
            title: '凭证字',
            align:"center",
            dataIndex: 'fvoucherGroup'
           },
		      {
            title: '凭证号',
            align:"center",
            dataIndex: 'fvoucherId'
           },
		      {
            title: '摘要',
            className:"column-text",
            dataIndex: 'fvoucherExp'
           },
		      {
            title: '科目编码',
            className:"column-text",
            dataIndex: 'faccountCode'
           },
		      {
            title: '科目名称',
            className:"column-text",
            dataIndex: 'faccountName'
           },
		      {
            title: '币别',
            className:"column-text",
            dataIndex: 'fcurrencyType'
           },
		       {
            title: '原币金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'forgTotal',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
          },
		      {
            title: '借方金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'fdebitTotal',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
           },
           {
            title: '贷方金额',
            //align:"center",
            className:'column-money',
            dataIndex: 'fcreditTotal',
            customRender: function(text) {
              return !text ? '': text.toLocaleString();
            }
           },
           {
            title: '审核',
            align:"center",
            dataIndex: 'fchecked'
           },
		       {
            title: '过账',
            align:"center",
            dataIndex: 'fposted'
           },
		       {
            title: '附件数',
            align:"center",
            dataIndex: 'fattachments'
           },
		       {
            title: '来源系统',
            align:"center",
            dataIndex: 'fsource'
           },
		      {
            title: '审核状态',
            align:"center",
            dataIndex: 'fauditStatus'
           },
		      {
            title: '作废状态',
            align:"center",
            dataIndex: 'fdeleteStatus'
           },
        ],
		url: {
          list: "/bms/bizFinancialVoucher/list",
          importExcelUrl: "bms/bizFinancialVoucher/importExcel",
       },
    }
  },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created() {
      //默认初始化参数
      let today = moment(new Date()).format('YYYY-MM-DD');
      this.queryParam.fyear = today.substr(0,4);
      this.queryParam.fperiod = today.substr(5,2);
      this.searchQuery();
    },
    methods: {
      searchQuery(){
        let year = this.queryParam.fyear;
        if(year === null && year === undefined && year  === ""){
          this.$message("年度不能为空");
          return;
        }
        let period = this.queryParam.fperiod;
        if(period === null && period === undefined && period === ""){
          this.$message("月份不能为空");
          return;
        }
        this.loadData(1);
      }
    }
  }
</script>
<style>
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>